// 화면에서 사용하는 데이터부 선언
export default {
	//tables : [],

	//Main
	// categorys: [
	// 	{ label: 'Select', value: '' },
	// 	{ label: '프로젝트관련', value: '프로젝트관련' },
	// 	{ label: '공통FW', value: '공통FW' },
	// 	{ label: '메인도메인', value: '메인도메인' },
	// 	{ label: '공통도메인', value: '공통도메인' }
	// ],

	// 선택한 테이블 Row
	//selectedRows: [],
	resultList: [],

	uploadFormList: [],

	useYnOptions: [],

	// 사용자 공통팝업 파라미터 정보
	searchUserPopParams: {
		userName: '',
		userId: ''
	},

	// 검색조건 파라미터 정보
	searchParams: {
		gqmsSeq: '',
		gqmsTitle: '',
		gqmsConts: '',
		useYn: 'Y'
	},

	refUploadFormTable: null,

	// 페이징 처리를 위한 정보 데이터부
	pagingInfo: {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	},

	groups: {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	},

	schema: null,

	//Modal
	UploadFormModal: false,
	UploadFormModalValue: {
		flg: 'I',
		gqmsSeq: '',
		gqmsTitle: '',
		gqmsConts: '1. 테스트 파일업로드 : ',
		fileId: '',
		file2Id: '',
		imgId1: '',
		imgFile1: {},
		imgId2: '',
		imgFile2: {},
		fileList: [],
		regId: ''
	},

	UploadFormDetail: false,
	UploadFormDetailValue: {
		gqmsSeq: '',
		gqmsTitle: '',
		gqmsConts: '',
		fileId: '',
		file2Id: '',
		imgId1: '',
		imgFile1: {},
		img1Url: '',
		imgId2: '',
		imgFile2: {},
		img2Url: '',
		imgPreviewName: [],
		imgPreviewList: [],
		fileList: [],
		regId: '',
		fileInfo: []
	}
};
